// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fcpZ","label":"styles_label__Q-Te1"};